<template>
<div class="kpi-container">
    <MonthKpiSummary :selectedMonth="selectedMonth" @animationDone="onAnimationDone"/>

<!--    <h2 class="globalHeader">Monatliche Wachstumsprämie</h2>-->
<!--    <MonthKPIRecruiting :selectedMonth="selectedMonth"/>-->



    <h2 class="globalHeader">Mein Bruttolohn</h2>
    <IonLabel class="hint">
        Die Lohnabrechnung wird dir jeden Monat über den Mitarbeiterzugang von zvoove bereit gestellt. Die Anmeldung erfolgt mit deinen persönlichen Zugangsdaten.
    </IonLabel>
    <a target="_blank" href="https://409073.landwehr-hosting.de/index.php?page=Login&login=Personal">
        <RichResponseButton title="Zur Lohnabrechnung"/>
    </a>

    <h2 class="globalHeaderWithSubHeader">Jahresüberschuss</h2>
    <h4 class="globalHeaderWithSubHeader">aller Fachkräfte bei <b style="color:var(--ion-color-superblack-tint)">ines</b></h4>
    <MonthKpiCompany :selectedMonth="selectedMonth"/>

    <IonButton :color="'primary'" @click="showExcessDetailModal = true" class="margin-top-regular">Wie ergibt sich mein Jahresüberschuss?</IonButton>

    <h2 class="globalHeader">Urlaubsanspruch</h2>
    <MonthKPIVacation :selectedMonth="selectedMonth"/>

    <h2 class="globalHeader">Arbeitszeitkonto (AZK)</h2>
    <MonthKPIAZK :selectedMonth="selectedMonth"/>
</div>

<Modal v-model="showExcessDetailModal" :title="'Wie ergibt sich mein Anteil?'">
    <MonthKPIExcessDetails :selected-month="props.selectedMonth"/>
</Modal>
</template>

<script setup lang="ts">
import Modal from '@/components/Modal.vue'
import {IonButton, IonLabel} from '@ionic/vue';
import {PropType, ref, Ref} from 'vue';
import {DataLoader} from "@/helper/dataLoader";
import {PayrollStatus} from "@/graphql/generated/graphql";

import {kapitelMonthString} from '@/graphql/kapitelTypes';
import MonthKpiCompany from "@/views/components/MonthKPI/section/MonthKPICompany.vue";
import MonthKPIVacation from "@/views/components/MonthKPI/section/MonthKPIVacation.vue";
import MonthKPIAZK from "@/views/components/MonthKPI/section/MonthKPIAZK.vue";
import MonthKpiSummary from "@/views/components/MonthKPI/section/MonthKPISummary.vue";
import {fetchPayrollStatusForMonth, setPayrollStatusSeen} from "@/helper/monthKPI/monthKpiPayroll";
import {useAuthStore} from "@/store/auth";
import MonthKPIExcessDetails from "@/views/components/MonthKPI/MonthKPIExcessDetails.vue";
import RichResponseButton from "@/views/Chat/RichResponses/components/RichResponseButton.vue";
import MonthKpiPlanningSummary from "@/views/components/MonthKPI/section/MonthKPIPlanningSummary.vue";

const props = defineProps({
    selectedMonth: {
        type: String as PropType<kapitelMonthString>,
        required: true,
    }
});

const showExcessDetailModal = ref(false)

// loader
const initialDataLoader = new DataLoader();

const payrollStatusForMonth : Ref<PayrollStatus | undefined> = ref(undefined);
initialDataLoader.add(async () => payrollStatusForMonth.value = await fetchPayrollStatusForMonth(props.selectedMonth))

initialDataLoader.load()

// animation
const onAnimationDone = () => {
    if (!payrollStatusForMonth.value) {
        return
    }
    if (useAuthStore().isImpersonating()) {
        console.info("skipping setSeen because of impersonation")
        return
    }
    setPayrollStatusSeen(payrollStatusForMonth.value.month as kapitelMonthString)
}

</script>

<style lang="scss" scoped>
.kpi-container {
    display: flex;
    flex-direction: column;
}
</style>
